import React from 'react';

class Home extends React.Component {
    render() {
        return (
            <div class="bg-stone-900 md:min-h-96 pt-16 md:pb-28 md:pt-28 px-5 md:px-0 md:-mt-32">
                <div class="container text-center md:text-left text-white p-5 mx-auto md:mt-32">
                    <div class="grid grid-cols-1 md:grid-cols-2 place-content-around">
                        <div>
                            <img src="/icon.png" class="w-72 right-img me-24" alt="icon" />
                        </div>
                        <div class="py-9">
                            <p class="text-base font-extrabold italic md:mt-2">Hey, it's me</p>
                            <h1 class="font-extrabold text-transparent text-6xl md:text-7xl lg:text-8xl bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">LiloStellar</h1>
                            <p clas="text-base font-extrabold">YOUR FULL STACK WEB DEVELOPER</p>
                            <div class="mt-6">
                                <a href="https://twitter.com/messages/compose?recipient_id=1311990073982808066" target="_blank" rel="noreferrer" class="hover:outline hover:outline-offset-4 rounded-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 px-5 py-3 font-bold">INQUIRE NOW</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default Home;